import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2ajh8bwwaf: FaireBrandEntity = {
  token: "b_2ajh8bwwaf",
  type: "brand",
  name: "Venchi",
  avatarUrl:
    "https://cdn.faire.com/fastly/298df181a5790248ea353f91f19a94fa0a7bd5eb8adf3ee4e4abf73e09bc540f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a26d196a121a850b420c07a3f7ce35774c45439b74a0320f9e49be4871dc23c7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/298df181a5790248ea353f91f19a94fa0a7bd5eb8adf3ee4e4abf73e09bc540f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a26d196a121a850b420c07a3f7ce35774c45439b74a0320f9e49be4871dc23c7.png",
  location: "NY, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 106,
  isTopShop: true,
  isInsider: true,
  description:
    '⭐⭐⭐⭐⭐ "Delightfully quick shipping, product is wonderful, just like I remember from our trip to Italy." - Kandi\n\nVenchi has been crafting Italian Chocolate since 1878, blending heritage, creativity, and joy into every recipe. Founded in Turin by Silviano Venchi, a passionate young chocolatier with a love for Piedmont hazelnuts and cocoa, the brand began with just two bronze cauldrons and a dream. More than 140 years later, Venchi is a global icon in luxury chocolate, with over 130 boutiques across 70 countries and a collection rooted in tradition, authenticity, and innovation.\n\nVenchi offers over 350 varieties of gourmet chocolate, all made using time-honored techniques and the highest-quality ingredients—extra-dark cocoa, caramelized hazelnuts, Italian olive oil, and recipes inspired by the Mediterranean diet. Signature offerings include layered Cremino, smooth Gianduiotti, crunchy Nougatine, and best-selling Suprema hazelnut spreads. Each piece delivers a sensory experience designed to spark joy and connection, in true Italian style.\n\nAs a heritage brand, Venchi brings unmatched credibility, artistry, and global recognition to any retail shelf. From giftable assortments to everyday indulgences, the brand delivers elevated, premium chocolate with strong visual appeal, elegant packaging, and high turnover potential. Retailers trust Venchi for its craftsmanship, consistency, and a legacy built on delighting chocolate lovers for generations.',
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:45.645Z",
    importedBy: "entity-db-cli",
  },
};
